// src/analytics/useGA4Pageviews.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendPageview } from './ga4';

export function useGA4Pageviews() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    sendPageview(pathname + search);
  }, [pathname, search]);
}
